import { easyPost } from './utils';

export const getCardInfo = easyPost('common.cardholder.getUpgradeInfo');

export const updateCard = easyPost('common.cardholder.confirmUpgrade');
